/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssignServiceRequestBody,
  GetApiServiceRequestsAssigneesParams,
  GetApiServiceRequestsParams,
  ProblemDetails,
  ServiceRequestDecisionBody,
  ServiceRequestDto,
  ServiceRequestDtoPaginationResult,
  ServiceRequestUserDto,
  ValidationProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiServiceRequests = (
    params?: GetApiServiceRequestsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ServiceRequestDtoPaginationResult>(
      {url: `/api/service-requests`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiServiceRequestsInfiniteQueryKey = (params?: GetApiServiceRequestsParams,) => {
    return [
    'infinite', `/api/service-requests`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiServiceRequestsQueryKey = (params?: GetApiServiceRequestsParams,) => {
    return [
    `/api/service-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiServiceRequestsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequests>>>, TError = ProblemDetails>(params?: GetApiServiceRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiServiceRequestsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiServiceRequests>>> = ({ signal }) => getApiServiceRequests(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiServiceRequestsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiServiceRequests>>>
export type GetApiServiceRequestsInfiniteQueryError = ProblemDetails


export function useGetApiServiceRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequests>>>, TError = ProblemDetails>(
 params: undefined |  GetApiServiceRequestsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequests>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequests>>>, TError = ProblemDetails>(
 params?: GetApiServiceRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequests>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequests>>>, TError = ProblemDetails>(
 params?: GetApiServiceRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiServiceRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequests>>>, TError = ProblemDetails>(
 params?: GetApiServiceRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiServiceRequestsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiServiceRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getApiServiceRequests>>, TError = ProblemDetails>(params?: GetApiServiceRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiServiceRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiServiceRequests>>> = ({ signal }) => getApiServiceRequests(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiServiceRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiServiceRequests>>>
export type GetApiServiceRequestsQueryError = ProblemDetails


export function useGetApiServiceRequests<TData = Awaited<ReturnType<typeof getApiServiceRequests>>, TError = ProblemDetails>(
 params: undefined |  GetApiServiceRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequests>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequests<TData = Awaited<ReturnType<typeof getApiServiceRequests>>, TError = ProblemDetails>(
 params?: GetApiServiceRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequests>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequests<TData = Awaited<ReturnType<typeof getApiServiceRequests>>, TError = ProblemDetails>(
 params?: GetApiServiceRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiServiceRequests<TData = Awaited<ReturnType<typeof getApiServiceRequests>>, TError = ProblemDetails>(
 params?: GetApiServiceRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiServiceRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiServiceRequestsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ServiceRequestDto>(
      {url: `/api/service-requests/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiServiceRequestsIdInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/service-requests/${id}`
    ] as const;
    }

export const getGetApiServiceRequestsIdQueryKey = (id: string,) => {
    return [
    `/api/service-requests/${id}`
    ] as const;
    }


export const getGetApiServiceRequestsIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsId>>>, TError = ProblemDetails | ServiceRequestDto>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiServiceRequestsIdInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiServiceRequestsId>>> = ({ signal }) => getApiServiceRequestsId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiServiceRequestsIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiServiceRequestsId>>>
export type GetApiServiceRequestsIdInfiniteQueryError = ProblemDetails | ServiceRequestDto


export function useGetApiServiceRequestsIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsId>>>, TError = ProblemDetails | ServiceRequestDto>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequestsId>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequestsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsId>>>, TError = ProblemDetails | ServiceRequestDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequestsId>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequestsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsId>>>, TError = ProblemDetails | ServiceRequestDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiServiceRequestsIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsId>>>, TError = ProblemDetails | ServiceRequestDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiServiceRequestsIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiServiceRequestsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError = ProblemDetails | ServiceRequestDto>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiServiceRequestsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiServiceRequestsId>>> = ({ signal }) => getApiServiceRequestsId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiServiceRequestsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiServiceRequestsId>>>
export type GetApiServiceRequestsIdQueryError = ProblemDetails | ServiceRequestDto


export function useGetApiServiceRequestsId<TData = Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError = ProblemDetails | ServiceRequestDto>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequestsId>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequestsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsId<TData = Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError = ProblemDetails | ServiceRequestDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequestsId>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequestsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsId<TData = Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError = ProblemDetails | ServiceRequestDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiServiceRequestsId<TData = Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError = ProblemDetails | ServiceRequestDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiServiceRequestsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiServiceRequestsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/service-requests/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiServiceRequestsIdMutationOptions = <TError = ProblemDetails | unknown | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiServiceRequestsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiServiceRequestsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiServiceRequestsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiServiceRequestsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiServiceRequestsId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiServiceRequestsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiServiceRequestsId>>>

    export type DeleteApiServiceRequestsIdMutationError = ProblemDetails | unknown | null

    export const useDeleteApiServiceRequestsId = <TError = ProblemDetails | unknown | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiServiceRequestsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiServiceRequestsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiServiceRequestsIdMutationOptions(options), queryClient);
    }
    export const postApiServiceRequestsIdComplete = (
    id: string,
    serviceRequestDecisionBody?: ServiceRequestDecisionBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ServiceRequestDto>(
      {url: `/api/service-requests/${id}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceRequestDecisionBody, signal
    },
      options);
    }




export const getPostApiServiceRequestsIdCompleteMutationOptions = <TError = ValidationProblemDetails | ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdComplete>>, TError,{id: string;data?: ServiceRequestDecisionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdComplete>>, TError,{id: string;data?: ServiceRequestDecisionBody}, TContext> => {

const mutationKey = ['postApiServiceRequestsIdComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiServiceRequestsIdComplete>>, {id: string;data?: ServiceRequestDecisionBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiServiceRequestsIdComplete(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiServiceRequestsIdCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postApiServiceRequestsIdComplete>>>
    export type PostApiServiceRequestsIdCompleteMutationBody = ServiceRequestDecisionBody | undefined
    export type PostApiServiceRequestsIdCompleteMutationError = ValidationProblemDetails | ProblemDetails | ServiceRequestDto

    export const usePostApiServiceRequestsIdComplete = <TError = ValidationProblemDetails | ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdComplete>>, TError,{id: string;data?: ServiceRequestDecisionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiServiceRequestsIdComplete>>,
        TError,
        {id: string;data?: ServiceRequestDecisionBody},
        TContext
      > => {
      return useMutation(getPostApiServiceRequestsIdCompleteMutationOptions(options), queryClient);
    }
    export const postApiServiceRequestsIdReject = (
    id: string,
    serviceRequestDecisionBody?: ServiceRequestDecisionBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ServiceRequestDto>(
      {url: `/api/service-requests/${id}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceRequestDecisionBody, signal
    },
      options);
    }




export const getPostApiServiceRequestsIdRejectMutationOptions = <TError = ValidationProblemDetails | ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdReject>>, TError,{id: string;data?: ServiceRequestDecisionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdReject>>, TError,{id: string;data?: ServiceRequestDecisionBody}, TContext> => {

const mutationKey = ['postApiServiceRequestsIdReject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiServiceRequestsIdReject>>, {id: string;data?: ServiceRequestDecisionBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiServiceRequestsIdReject(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiServiceRequestsIdRejectMutationResult = NonNullable<Awaited<ReturnType<typeof postApiServiceRequestsIdReject>>>
    export type PostApiServiceRequestsIdRejectMutationBody = ServiceRequestDecisionBody | undefined
    export type PostApiServiceRequestsIdRejectMutationError = ValidationProblemDetails | ProblemDetails | ServiceRequestDto

    export const usePostApiServiceRequestsIdReject = <TError = ValidationProblemDetails | ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdReject>>, TError,{id: string;data?: ServiceRequestDecisionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiServiceRequestsIdReject>>,
        TError,
        {id: string;data?: ServiceRequestDecisionBody},
        TContext
      > => {
      return useMutation(getPostApiServiceRequestsIdRejectMutationOptions(options), queryClient);
    }
    export const getApiServiceRequestsAssignees = (
    params?: GetApiServiceRequestsAssigneesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ServiceRequestUserDto[] | null>(
      {url: `/api/service-requests/assignees`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiServiceRequestsAssigneesInfiniteQueryKey = (params?: GetApiServiceRequestsAssigneesParams,) => {
    return [
    'infinite', `/api/service-requests/assignees`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiServiceRequestsAssigneesQueryKey = (params?: GetApiServiceRequestsAssigneesParams,) => {
    return [
    `/api/service-requests/assignees`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiServiceRequestsAssigneesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>>, TError = ValidationProblemDetails | ProblemDetails>(params?: GetApiServiceRequestsAssigneesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiServiceRequestsAssigneesInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>> = ({ signal }) => getApiServiceRequestsAssignees(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiServiceRequestsAssigneesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>>
export type GetApiServiceRequestsAssigneesInfiniteQueryError = ValidationProblemDetails | ProblemDetails


export function useGetApiServiceRequestsAssigneesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>>, TError = ValidationProblemDetails | ProblemDetails>(
 params: undefined |  GetApiServiceRequestsAssigneesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsAssigneesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>>, TError = ValidationProblemDetails | ProblemDetails>(
 params?: GetApiServiceRequestsAssigneesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsAssigneesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>>, TError = ValidationProblemDetails | ProblemDetails>(
 params?: GetApiServiceRequestsAssigneesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiServiceRequestsAssigneesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>>, TError = ValidationProblemDetails | ProblemDetails>(
 params?: GetApiServiceRequestsAssigneesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiServiceRequestsAssigneesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiServiceRequestsAssigneesQueryOptions = <TData = Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError = ValidationProblemDetails | ProblemDetails>(params?: GetApiServiceRequestsAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiServiceRequestsAssigneesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>> = ({ signal }) => getApiServiceRequestsAssignees(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiServiceRequestsAssigneesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>>
export type GetApiServiceRequestsAssigneesQueryError = ValidationProblemDetails | ProblemDetails


export function useGetApiServiceRequestsAssignees<TData = Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError = ValidationProblemDetails | ProblemDetails>(
 params: undefined |  GetApiServiceRequestsAssigneesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsAssignees<TData = Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError = ValidationProblemDetails | ProblemDetails>(
 params?: GetApiServiceRequestsAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>,
          TError,
          Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiServiceRequestsAssignees<TData = Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError = ValidationProblemDetails | ProblemDetails>(
 params?: GetApiServiceRequestsAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiServiceRequestsAssignees<TData = Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError = ValidationProblemDetails | ProblemDetails>(
 params?: GetApiServiceRequestsAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiServiceRequestsAssignees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiServiceRequestsAssigneesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiServiceRequestsIdAssignee = (
    id: string,
    assignServiceRequestBody?: AssignServiceRequestBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ServiceRequestDto>(
      {url: `/api/service-requests/${id}/assignee`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: assignServiceRequestBody, signal
    },
      options);
    }




export const getPutApiServiceRequestsIdAssigneeMutationOptions = <TError = ValidationProblemDetails | ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiServiceRequestsIdAssignee>>, TError,{id: string;data?: AssignServiceRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiServiceRequestsIdAssignee>>, TError,{id: string;data?: AssignServiceRequestBody}, TContext> => {

const mutationKey = ['putApiServiceRequestsIdAssignee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiServiceRequestsIdAssignee>>, {id: string;data?: AssignServiceRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiServiceRequestsIdAssignee(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiServiceRequestsIdAssigneeMutationResult = NonNullable<Awaited<ReturnType<typeof putApiServiceRequestsIdAssignee>>>
    export type PutApiServiceRequestsIdAssigneeMutationBody = AssignServiceRequestBody | undefined
    export type PutApiServiceRequestsIdAssigneeMutationError = ValidationProblemDetails | ProblemDetails | ServiceRequestDto

    export const usePutApiServiceRequestsIdAssignee = <TError = ValidationProblemDetails | ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiServiceRequestsIdAssignee>>, TError,{id: string;data?: AssignServiceRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiServiceRequestsIdAssignee>>,
        TError,
        {id: string;data?: AssignServiceRequestBody},
        TContext
      > => {
      return useMutation(getPutApiServiceRequestsIdAssigneeMutationOptions(options), queryClient);
    }
    export const postApiServiceRequestsIdArchive = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ServiceRequestDto>(
      {url: `/api/service-requests/${id}/archive`, method: 'POST', signal
    },
      options);
    }




export const getPostApiServiceRequestsIdArchiveMutationOptions = <TError = ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdArchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdArchive>>, TError,{id: string}, TContext> => {

const mutationKey = ['postApiServiceRequestsIdArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiServiceRequestsIdArchive>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postApiServiceRequestsIdArchive(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiServiceRequestsIdArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiServiceRequestsIdArchive>>>

    export type PostApiServiceRequestsIdArchiveMutationError = ProblemDetails | ServiceRequestDto

    export const usePostApiServiceRequestsIdArchive = <TError = ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdArchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiServiceRequestsIdArchive>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPostApiServiceRequestsIdArchiveMutationOptions(options), queryClient);
    }
    export const postApiServiceRequestsIdUnarchive = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ServiceRequestDto>(
      {url: `/api/service-requests/${id}/unarchive`, method: 'POST', signal
    },
      options);
    }




export const getPostApiServiceRequestsIdUnarchiveMutationOptions = <TError = ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdUnarchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdUnarchive>>, TError,{id: string}, TContext> => {

const mutationKey = ['postApiServiceRequestsIdUnarchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiServiceRequestsIdUnarchive>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postApiServiceRequestsIdUnarchive(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiServiceRequestsIdUnarchiveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiServiceRequestsIdUnarchive>>>

    export type PostApiServiceRequestsIdUnarchiveMutationError = ProblemDetails | ServiceRequestDto

    export const usePostApiServiceRequestsIdUnarchive = <TError = ProblemDetails | ServiceRequestDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiServiceRequestsIdUnarchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiServiceRequestsIdUnarchive>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPostApiServiceRequestsIdUnarchiveMutationOptions(options), queryClient);
    }
